<template lang="pug">
    v-card.no-padding(outlined tile v-if="renderCustomerSearchCreate")
        v-toolbar(color="var(--off-white)" light dense)
            v-icon(style="margin-right: 5px;") mdi-account
            v-toolbar-title
                template(v-if="isSwitchingCustomer") Switching Customer:
                template(v-else) {{ currentCampaign.organization_name }}
            template(v-if="isSwitchingCustomer")
                span.ml-4(style="font-size: 0.80rem;")
                    strong {{ currentCampaign.organization_name }}
            v-spacer
            VoiceMailRecordingDialog(
                v-if="renderVoiceMailRecordingDetails"
                :call-id="callId"
                :end-voice-mail-recording="endVoiceMailRecording"
                :show-snackbar="showSnackbar"
                :start-force-start-next-dial="startForceStartNextDial"
                :voice-mail-recording="voiceMailRecording"
            )
            SavedPlaceInLineDialog(
                v-if="renderSavedPlaceDialog"
                :saved-place-in-line-call="savedPlaceInLineCall"
            )
        v-row(
            dense
            v-bind:style="{ height: cardBodyHeight + 'px' }"
        )
            v-col.col-right-divider(cols='6')
                v-tabs(grow show-arrows light v-model="leftCurrentTab")
                    v-tab(
                        v-for='(item, i) in leftItems'
                        :key='item.key'
                    )
                        | {{ item.name }}

                v-tabs-items(v-model="leftCurrentTab")
                    v-tab-item(key="search-customer")
                        CustomerSearch.overflow-y-auto(
                            :call="call"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                            :begin-manual-mode-outbound-dial-while-already-in-manual-mode="beginManualModeOutboundDialWhileAlreadyInManualMode"
                            :cancel-switch-customer="cancelSwitchCustomer"
                            :current-campaign-customer="currentCampaignCustomer"
                            :enroll-campaign-customer="enrollCampaignCustomer"
                            :enrollment-loading="enrollmentLoading"
                            :force-validated-outbound-number="forceValidatedOutboundNumber"
                            :force-toggle-search-is-loading="forceToggleSearchIsLoading"
                            :initial-email-address="initialEmailAddress"
                            :initial-first-name="initialFirstName"
                            :initial-last-name="initialLastName"
                            :initial-phone-number="initialPhoneNumber"
                            :is-supervisor="isSupervisor"
                            :is-live-dash-inbound-call="isLiveDashInboundCall"
                            :is-switching-customer="isSwitchingCustomer"
                            :is-manual-mode="isManualMode"
                            :loading-customer-id="loadingCustomerId"
                            :organization-id="currentCampaign.organization_id"
                            :organization-users="organizationUsers"
                            :start-force-start-next-dial="startForceStartNextDial"
                            :switch-customer-for-campaign-customer-active="switchCustomerForCampaignCustomerActive"
                        )
                    v-tab-item(key="create-customer")
                        CustomerCreate.overflow-y-auto(
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                            :cancel-switch-customer="cancelSwitchCustomer"
                            :communication-type="communicationType"
                            :enroll-campaign-customer="enrollCampaignCustomer"
                            :enrollment-loading="enrollmentLoading"
                            :initial-address="initialAddress"
                            :initial-email-address="initialEmailAddress"
                            :initial-first-name="initialFirstName"
                            :initial-last-name="initialLastName"
                            :initial-cell-phone="initialPhoneNumber"
                            :is-supervisor="isSupervisor"
                            :is-live-dash-inbound-call="isLiveDashInboundCall"
                            :is-switching-customer="isSwitchingCustomer"
                            :organization-id="currentCampaign.organization_id"
                            :organization-users="organizationUsers"
                            :switch-customer-for-campaign-customer-active="switchCustomerForCampaignCustomerActive"
                        )
                    v-tab-item(key="disposition")
                        DispositionTab.overflow-y-auto(
                            :call-failed="callFailed"
                            :call-id="callId"
                            :communication-type="communicationType"
                            :create-agent="createAgent"
                            :create-survey-attempt="createSurveyAttempt"
                            :current-campaign-customer="currentCampaignCustomer"
                            :finish-save-and-next-overlay="finishSaveAndNextOverlay"
                            :initiate-create-communication-disposition="initiateCreateCommunicationDisposition"
                            :is-manual-mode="isManualMode"
                            :is-paused-voice-mail-recording="isPausedVoiceMailRecording"
                            :is-saved-place-call="isSavedPlaceCall"
                            :is-live-dash-inbound-call="isLiveDashInboundCall"
                            :missed-call-from-call-screen="missedCallFromCallScreen"
                            :parent-disposition-notes="parentDispositionNotes"
                            :pending-saved-place-call="savedPlaceInLineCall"
                            :set-is-okay-to-create-communication-disposition="setIsOkayToCreateCommunicationDisposition"
                            :set-is-okay-to-save-and-next="setIsOkayToSaveAndNext"
                            :set-selected-campaign-disposition="setSelectedCampaignDisposition"
                            :show-snackbar="showSnackbar"
                            :start-save-and-next="startSaveAndNext"
                            :sync-disposition-notes="syncDispositionNotes"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                            :voice-mail-recording="voiceMailRecording"
                            :select-most-used-disposition="leftCurrentTab === 2"
                        )

            v-col.col-left-divider(cols='6')
                v-tabs(grow show-arrows light v-model='rightCurrentTab')
                    v-tab(v-for='item in rightItems' :key='item.key' :href="item.href")
                        img.tab-image.mr-2(v-if="item.image" :src="item.image" :alt="item.name")
                        | {{ item.name }}
                    v-menu(v-if='rightMore.length' bottom left)
                        template(v-slot:activator='{ on }')
                            v-btn.align-self-center.mr-4(text v-on='on')
                                | more
                                v-icon(right) mdi-menu-down
                        v-list.grey.lighten-5
                            v-list-item(v-for='item in rightMore' :key='item.key' @click='addRightItem(item)')
                                | {{ item.name }}

                v-tabs-items
                    keep-alive
                        CarlieDetails.overflow-y-auto.pa-4(
                            v-if="rightCurrentTab === 'carlie-tab' && carlieTab"
                            :ai-communication-id="carlieTab.aiCommunicationId"
                            :context="carlieTab.context"
                            :initial-details="carlieTab.details"
                            :live-analysis="carlieTab.analysis"
                            :recording-url="voiceMailRecording?.recording_url || ''"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        ContactsTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'contacts-tab'"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                            :call-id="callId"
                            :on-call="onCall"
                            :open-transfer-dialog="openTransferDialog"
                            :organization-id="currentCampaign.organization_id"
                        )
                        ExternalLinksTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'external-links-tab'"
                            :campaign-id="currentCampaign.campaign_id"
                            :organization-id="currentCampaign.organization_id"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        OrganizationTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'organization-tab'"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                            :campaign-id="currentCampaign.campaign_id"
                            :organization-id="currentCampaign.organization_id"
                        )
                        PromotionsTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'promotions-tab'"
                            :campaign-id="currentCampaign.campaign_id"
                            :organization-id="currentCampaign.organization_id"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        AutoAssistantTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'auto-assistant-tab' && this.callId > 0"
                            :call-id="callId"
                            :in-communication-center="true"
                            :auto-assist-data="autoAssistData"
                            :transferred-from-auto-assist="hasAutoAssistData"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Components
    import AutoAssistantTab from '@/components/communication_center/shared/tabs/auto_assistant.vue';
    import CarlieDetails from '@/components/carlie/carlie_details.vue';
    import ContactsTab from '@/components/communication_center/shared/tabs/contacts.vue';
    import CustomerCreate from '@/components/customers/form.vue';
    import CustomerSearch from '@/components/customers/search.vue';
    import DispositionTab from '@/components/communication_center/shared/tabs/disposition.vue';
    import ExternalLinksTab from '@/components/communication_center/shared/tabs/external_links.vue';
    import OrganizationTab from '@/components/communication_center/shared/tabs/organization.vue';
    import PromotionsTab from '@/components/communication_center/shared/tabs/promotions.vue';
    import SavedPlaceInLineDialog from '@/components/communication_center/shared/saved_place_in_line_dialog.vue';
    import VoiceMailRecordingDialog from '@/components/voice_mail_recordings/dialog.vue';
    import carlieLogo from '@/components/carlie/carlie_logo.png';

    // Data
    import { EnrollCampaignCustomer } from "@/data";

    // Helpers
    import { carlieTabSource } from '@/helpers/carlie';
    import { formatName } from "@/helpers/name";

    export default Vue.extend({
        data() {
            return {
                autoAssistantName: "Auto Assistant",
                cachedCustomerID: null,
                cachedParams: null,
                cardBodyHeight: null,
                enrollmentLoading: false,
                forceToggleSearchIsLoading: false,
                forceOverrideAll: false,
                fullName: null,
                leftCurrentTab: null,
                leftItems: [
                    { name: "Search", key: "search-customer", href: "#search-customer-tab" },
                    { name: "Create", key: "create-customer", href: "#create-customer-tab" },
                ],
                loadingCustomerId: null,
                manualAutoDialError: null,
                manualModeEnrollmentError: null,
                rightCurrentTab: null,                rightMore: [
                    { name: "Contacts", key: "contacts", href: "#contacts-tab" },
                    { name: "External Links", key: "external_links", href: "#external-links-tab" },
                    { name: "Promotions", key: "promotions", href: "#promotions-tab" },
                ],
                rightItems: [
                    { name: "Organization", key: "organization", href: "#organization-tab" },
                ],
                tabContentHeight: null,
            }
        },
        methods: {
            addRightItem (item) {
                const removed = this.rightItems.splice(0, 1);
                this.rightItems.push(
                    ...this.rightMore.splice(this.rightMore.indexOf(item), 1)
                );
                this.rightMore.push(...removed);
                this.rightMore.sort((a, b) => {
                    if (a.name < b.name) {
                        return -1
                    }
                    if (a.name > b.name) {
                        return 1
                    }
                    return 0
                });
                this.$nextTick(() => { this.rightCurrentTab = item.href });
            },
            enableReceptionMode(override) {

                // Reception mode support
                if (!this.validReceptionMode && !override) {
                    return;
                }

                // Add if necessary
                if (!this.leftItemsInclude("disposition")) {
                    this.leftItems.push({ name: "Submit Disposition", key: "disposition", href: "#disposition-tab" });
                }
            },
            enrollCampaignCustomer(customerID, params) {

                // Verify campaign & customer ID are present
                if (!this.currentCampaign?.campaign_id || !customerID) {
                    return;
                }

                // Manual mode simulated enrollments always force override — skip the web request
                if (params.is_simulated && this.isManualMode) {
                    this.forceOverrideAll = true;
                    this.startForceStartNextDial();
                    return;
                }

                // Init
                const options = {
                    attempt_key: (this.currentAgent?.attempt_key || ''),
                    call_id: (this.call?.id || 0),
                    campaign_customer_id: (params?.campaign_customer_id || 0),
                    campaign_id: (this.currentCampaign?.campaign_id || 0),
                    customer_id: customerID,
                    expiration_code: 11,
                    force: true,
                    is_manual_mode: this.isManualMode === true,
                    is_simulated: params.is_simulated,
                    next_attemptable_id: (params?.next_attemptable_id || 0),
                    next_attemptable_type: (params?.next_attemptable_type || ''),
                    next_attemptable_value: (params?.next_attemptable_value || ''),
                    noticeable_id: (params?.noticeable_id || 0),
                    noticeable_type: (params?.noticeable_type || ''),
                    override_all: false,
                    purpose: this.enrollmentPurpose,
                    source: 5,
                    vehicle_id: (params?.vehicle_id || 0),
                    voice_mail_recording_id: (this.voiceMailRecording?.voice_mail_recording_id || 0),
                }

                // If inbound or missed call (or forced via manual mode), override all
                if (this.call?.direction === "inbound" || options.voice_mail_recording_id > 0 || this.forceOverrideAll) {
                    options.override_all = true;
                }

                // If communication type is sms message or email, need to enroll for a real eligible case
                if (this.communicationType === "Email" || this.communicationType === "SMS Message") {
                    options.expiration_code = 0;
                }

                // If manual mode and enroll as eligible, then set expiration to 0 (should also have been called as a return call but needs to be changed to default)
                if (this.isManualMode && this.manualModeEnrollAsEligible && this.enrollmentPurpose === "return_call") {
                    options.expiration_code = 0;
                    options.purpose = "default";
                }

                this.enrollmentLoading = true;
                this.loadingCustomerId = customerID;

                EnrollCampaignCustomer(options).then((response) => {
                    if (response?.Data?.campaign_customer_active?.campaign_customer_active_id > 0) {
                        // Need to add cc active to front of cc array and then make the active record
                        this.newEnrollmentSuccess(response.Data.campaign_customer_active, false);
                    } else if (params.is_simulated) {
                        // in case of simulated enrollment (manual mode auto enroll) we need to handle succes and failure cases
                        if (response?.Error === "Customer is eligible to be enrolled, but enrollment is simulated" || response?.Error === "Customer is already enrolled but this is a simulated enrollment") {
                            // if error matches success, we need to let the call screen know to start auto dial
                            this.startForceStartNextDial();
                        } else {
                            // enrollment error on simulated path — force override and proceed to dial
                            this.forceOverrideAll = true;
                            this.startForceStartNextDial();
                        }
                    } else if (response?.Error === "Unable to set next attemptable") {
                        if (this.communicationType === "Phone") {
                            this.showSnackbar("error", "The customer does not have any dialable phone numbers on profile.");
                        } else if (this.communicationType === "SMS Message") {
                            this.showSnackbar("error", "The customer does not have any textable phone numbers on profile.");
                        }
                    } else if (response?.Error?.length > 0) {
                        if (this.isManualMode) {
                            // force override and re-enroll without blocking the agent
                            this.forceOverrideAll = true;
                            this.enrollCampaignCustomer(customerID, params);
                        } else {
                            this.showSnackbar("error", response?.Error);
                        }
                    }
                }).finally(() => {
                    this.enrollmentLoading = false;
                });
            },
            goToAutoAssistantTab() {
                this.addRightItem({ key: 'auto-assistant', name: this.autoAssistantName, href: 'auto-assistant-tab'});
            },
            goToCarlieTab() {
                if (this.rightItems.some((tab) => tab.key === 'carlie')) {
                    return;
                }

                let carlieTab = this.rightMore.find((tab) => tab.key === 'carlie');
                if (!carlieTab) {
                    carlieTab = { key: 'carlie', name: 'Carlie', href: 'carlie-tab', image: carlieLogo };
                    this.rightMore.push(carlieTab);
                }
                this.addRightItem(carlieTab);
            },
            handleWindowResize() {

                // Declare constants
                const paddingPx = 2;
                const toolbarHeight = 48;
                const tabBarHeight = 48;
                const colPaddingAndMargin = 47.109;

                // Calcuate
                this.cardBodyHeight = this.cardHeight - paddingPx - toolbarHeight;
                this.tabContentHeight = this.cardBodyHeight - tabBarHeight - colPaddingAndMargin;
            },
            leftItemsInclude(key) {

                // Verify
                if (!key || !this.leftItems) {
                    return;
                }

                let found = false;
                for(let i = 0; i < this.leftItems.length; i++) {
                    if (this.leftItems[i].key === key) {
                        found = true;
                        break;
                    }
                }

                return found;
            },
            setAutoAssistantName() {

                // Set name if not already set
                if (this.autoAssistantName === "Auto Assistant") {
                    switch (this.autoAssistData?.auto_assistant_type) {
                        case 'stella':
                            this.autoAssistantName = 'Stella Ai';
                            break;
                        default:
                            this.autoAssistantName = 'Auto Assistant';
                    }
                }

                // Assign name to tab 
                this.rightItems.forEach((item) => {
                    if (item.key === 'auto-assistant') {
                        item.name = this.autoAssistantName;
                    }
                });

                this.rightMore.forEach((item) => {
                    if (item.key === 'auto-assistant') {
                        item.name = this.autoAssistantName;
                    }
                });
            },
        },
        computed: {
            callIsInbound() {
                return this.call?.id > 0 && this.call?.direction === "inbound";
            },
            currentAgent() {
                return VolieState.currentAgent();
            },
            currentUser() {
                return VolieState.currentUser();
            },
            forceCustomerID() {
                return (this.forceCustomer?.customer_id || 0);
            },
            receptionModeEnabled() {
                return this.currentUser?.account_user?.reception_mode_enabled === true || this.isSavedPlaceCall;
            },
            renderCustomerSearchCreate() {
                return (this.currentCampaign?.campaign_id > 0) && ((this.validCurrentCampaignCustomer && this.isSwitchingCustomer === true) || !this.validCurrentCampaignCustomer);
            },
            renderVoiceMailRecordingDetails() {
                return this.voiceMailRecording?.voice_mail_recording_id > 0;
            },
            renderSavedPlaceDialog() {
                return this.savedPlaceInLineCall?.call_communication_queue?.call_communication_queue_id > 0
            },
            validCurrentCampaignCustomer() {
                return this.currentCampaignCustomer?.campaign_customer_active_id > 0;
            },
            validReceptionMode() {
                return this.callIsInbound && this.receptionModeEnabled;
            },
            carlieTab() {
                return carlieTabSource(this.carlieLiveHandoff, this.voiceMailRecording);
            },
        },
        components: {
            AutoAssistantTab,
            CarlieDetails,
            ContactsTab,
            CustomerCreate,
            CustomerSearch,
            DispositionTab,
            ExternalLinksTab,
            OrganizationTab,
            PromotionsTab,
            SavedPlaceInLineDialog,
            VoiceMailRecordingDialog,
        },
        props: {
            autoAssistData: Object,
            beginManualModeOutboundDialWhileAlreadyInManualMode: Function,
            call: Object,
            callFailed: Boolean,
            callId: Number,
            cancelSwitchCustomer: Function,
            cardHeight: Number,
            carlieLiveHandoff: Object,
            communicationType: String,
            createAgent: Function,
            createSurveyAttempt: Function,
            currentCampaign: Object,
            currentCampaignCustomer: Object,
            endCall: Function,
            endVoiceMailRecording: Function,
            enrollmentPurpose: String,
            finishSaveAndNextOverlay: Function,
            forceCustomer: Object,
            forceValidatedOutboundNumber: String,
            hasAutoAssistData: Boolean,
            initialAddress: Object,
            initialEmailAddress: String,
            initialFirstName: String,
            initialLastName: String,
            initialPhoneNumber: String,
            initiateCreateCommunicationDisposition: Boolean,
            isHandlingInboundCall: Boolean,
            isManualMode: Boolean,
            isPausedVoiceMailRecording: Boolean,
            isSavedPlaceCall: Boolean,
            isSupervisor: Boolean,
            isLiveDashInboundCall: Boolean,
            isSwitchingCustomer: Boolean,
            manualModeEnrollAsEligible: Boolean,
            missedCallFromCallScreen: Boolean,
            newEnrollmentSuccess: Function,
            onCall: Boolean,
            openTransferDialog: Function,
            organizationUsers: Array,
            parentDispositionNotes: String,
            savedPlaceInLineCall: Object,
            setIsOkayToCreateCommunicationDisposition: Function,
            setIsOkayToSaveAndNext: Function,
            setSelectedCampaignDisposition: Function,
            showSnackbar: Function,
            startForceStartNextDial: Function,
            startSaveAndNext: Function,
            switchCustomerForCampaignCustomerActive: Function,
            syncDispositionNotes: Function,
            voiceMailRecording: Object,
        },
        destroyed() {
            window.removeEventListener('resize', this.handleWindowResize);
        },
        created() {
            window.addEventListener('resize', this.handleWindowResize);
            this.enableReceptionMode(this.isSavedPlaceCall);

            // If force customer is present on start and no active record exists, push through right away
            // (skip while an accepted inbound owns the customer context, e.g. inbound taken from manual mode)
            if (this.forceCustomerID > 0 && !(this.currentCampaignCustomer?.campaign_customer_active_id > 0) && !this.isHandlingInboundCall) {

                const params = {
                    campaign_customer_id: (this.forceCustomer?.campaign_customer_id || 0),
                    next_attemptable_id: (this.forceCustomer?.next_attemptable_id || 0),
                    next_attemptable_type: (this.forceCustomer?.next_attemptable_type || ''),
                    next_attemptable_value: (this.forceCustomer?.next_attemptable_value || ''),
                    noticeable_id: (this.forceCustomer?.noticeable_id || 0),
                    noticeable_type: (this.forceCustomer?.noticeable_type || ''),
                    vehicle_id: (this.forceCustomer?.vehicle_id || 0),
                }

                this.enrollCampaignCustomer(this.forceCustomerID, params);
            }

            if (this.hasAutoAssistData) {
                this.rightMore.push({ key: 'auto-assistant', name: this.autoAssistantName, href: 'auto-assistant-tab'})
                this.goToAutoAssistantTab();
            }

            if (this.carlieTab) {
                this.goToCarlieTab();
            }
        },
        mounted() {
            this.handleWindowResize();
        },
        watch: {
            autoAssistData: {
                deep: true,
                handler() {
                    this.setAutoAssistantName();
                },
            },
            hasAutoAssistData: {
                deep: true,
                handler() {
                    if (this.hasAutoAssistData) {
                        this.rightMore.push({ key: 'auto-assistant', name: this.autoAssistantName, href: 'auto-assistant-tab'})
                        this.goToAutoAssistantTab();
                    }
                },
            },
            call: {
                deep: true,
                handler() {
                    this.enableReceptionMode(this.isSavedPlaceCall);
                },
            },
            cardHeight() {
                Vue.nextTick(() => { this.handleWindowResize(); });
            },
            'carlieTab.context'(value) {
                if (value) {
                    this.goToCarlieTab();
                }
            },
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .col-right-divider {
            border-right: 1px solid var(--off-white);
            margin-top: 1%;
            margin-bottom: 2%;
            padding: 10px 20px 10px 20px;
        }

        .col-left-divider {
            border-left: 1px solid var(--off-white);
            margin-top: 1%;
            margin-bottom: 2%;
            padding: 10px 20px 10px 20px;
        }
    }

    .tab-image {
        height: 18px;
        width: 18px;
    }
</style>